import React, { memo } from 'react';
import cn from 'classnames';

import { AdvantagesProps } from './types';
import starsSprite from '../../images/stars.svg';
import whitePawnSprite from '../../images/pawn-white.svg';
import blackPawnSprite from '../../images/pawn-black.svg';
import styles from './Advantages.module.scss';

const Advantages = memo(function Advantages(props: AdvantagesProps) {
  const { data, title } = props;
  return (
    <div className={styles.main}>
      <div className={styles.contentWrapper}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.advantagesList}>
          {data.map((item, i) => (
            <div key={item} className={cn(styles.item, styles[`item_${i}`])}>
              {item}
            </div>
          ))}
        </div>
        <div
          className={cn(styles.backgroundStatic, styles.icon, styles.whitePawnSprite)}
          style={{
            backgroundImage: `url(${whitePawnSprite})`,
          }}
        />
        <div
          className={cn(styles.backgroundStatic, styles.starsSvg)}
          style={{
            backgroundImage: `url(${starsSprite})`,
          }}
        />
        <div
          className={cn(styles.backgroundStatic, styles.icon, styles.blackPawnSprite)}
          style={{
            backgroundImage: `url(${blackPawnSprite})`,
          }}
        />
      </div>
    </div>
  );
});

export { Advantages };
